module.exports = __webpack_public_path__ + "img/globalnda_caps-yellow-cutout.514017de.png";